import { screen } from '@/constants'

const mixin = {
  data: () => ({
    windowWidth: 0,
    windowHeight: 0,
    isScreenXl: false
  }),

  mounted () {
    this.onResize()
    window.onresize = this.onResize
  },

  methods: {
    onResize () {
      this.windowWidth = window.innerWidth
      this.windowHeight = window.innerHeight
      this.isScreenXl = this.windowWidth >= screen.screenWidthXl
    }
  }
}


export default mixin
